import { useMemo, useState, type ReactNode } from 'react';

import { NotificationSettings } from './notification-settings';
import { OutlookConnectSettings } from './outlook-connect-settings';
import { SettingsPanelContext } from './settings-panel-context';

/**
 * Dedicated settings panel component for chat area.
 * Displays settings content inline within the main chat content area
 * instead of as a modal dialog overlay.
 *
 * Provides SettingsPanelContext so any settings card can push a full-panel
 * sub-view (e.g. the Outlook manage view) without this component needing to
 * know what's inside it.
 */
export function ChatSettingsPanel() {
  const [activeView, setActiveView] = useState<ReactNode>(null);

  return (
    <SettingsPanelContext.Provider
      value={useMemo(() => ({ pushView: setActiveView, popView: () => setActiveView(null) }), [])}
    >
      <div className="flex size-full min-w-0 flex-col">
        <div className="flex flex-1 items-start justify-center p-6">
          <div className="flex w-full max-w-md flex-col gap-4">
            {activeView ?? (
              <>
                <NotificationSettings />
                <OutlookConnectSettings />
              </>
            )}
          </div>
        </div>
      </div>
    </SettingsPanelContext.Provider>
  );
}
